import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Ink Bleed Reveal
// Category: overlays · Tags: ink, bleed, reveal, transition, organic
export default function FxInkBleedReveal800Ms() {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 30, stiffness: 80 } });
  // Ink expands from center
  const radius = interpolate(p, [0, 1], [0, Math.max(width, height) * 0.9]);
  const innerOpacity = interpolate(p, [0.2, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  // Multiple blob layers for organic feel
  const blobs = Array.from({ length: 6 }).map((_, i) => {
    const angle = (i / 6) * Math.PI * 2;
    const r = radius * (0.7 + 0.3 * Math.sin(frame * 0.08 + i));
    return {
      cx: width / 2 + Math.cos(angle) * radius * 0.15,
      cy: height / 2 + Math.sin(angle) * radius * 0.15,
      r,
    };
  });

  return (
    <AbsoluteFill style={{ background: "#f8fafc" }}>
      {/* Content underneath */}
      <AbsoluteFill style={{ alignItems: "center", justifyContent: "center", opacity: innerOpacity }}>
        <span style={{ fontSize: 96, fontWeight: 900, color: "#f8fafc", fontFamily: "Georgia, serif" }}>REVEAL</span>
      </AbsoluteFill>
      {/* Ink mask via SVG */}
      <svg width="100%" height="100%" style={{ position: "absolute", inset: 0 }}>
        <defs>
          <filter id="inkBlur">
            <feGaussianBlur stdDeviation="8" />
          </filter>
          <mask id="inkMask">
            <rect width="100%" height="100%" fill="white" />
            <g filter="url(#inkBlur)">
              {blobs.map((b, i) => (
                <circle key={i} cx={b.cx} cy={b.cy} r={b.r} fill="black" />
              ))}
              <circle cx={width / 2} cy={height / 2} r={radius} fill="black" />
            </g>
          </mask>
        </defs>
        <rect width="100%" height="100%" fill="#0a0e1a" mask="url(#inkMask)" />
      </svg>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
